import React from 'react';

type Props = {
  rating: number;
};
export default function ProgressBar({ rating }: Props) {
  const fillPercentage = Math.ceil((rating / 5) * 100);
  const remainingPercentage = 100 - fillPercentage;

  return (
    <div
      style={{ width: '110px', height: '6px' }}
      className="relative rounded-[30px]"
    >
      <div
        style={{
          width: `${fillPercentage}%`,
          height: '100%',
        }}
        className="rounded-[30px] bg-primary"
      />
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: `${remainingPercentage}%`,
          height: '100%',
        }}
        className="rounded-e-[30px] bg-rose-200"
      />
    </div>
  );
}
